<div class="main-page">
  <nav class="navbar navbar-expand-lg navbar-light bg-light header">

    <!-- <a class="navbar-brand" routerLink="/select-criteria"> <span class="nav-divnk time" ><i class="fa fa-long-arrow-left" style="font-size:48px;color:#fff;margin-top:-16px;"></i></span></a> -->
    <!-- <div class="form-inline my-2 my-lg-0">
          <span class="nav-divnk">Make Payment</span>
      </div> -->

    <div class="logo"><a routerlink="/dashboard" ng-reflect-router-link="/dashboard"><img src="assets/logo-4.png"></a>
    </div>
  </nav>

  <div class="container">
    <div class="payment-success">
      <div class="payment-success-inner">
        <div class="container1">
          <div></div>
          <div></div>
          <div></div>
          <div class="active"></div>
        </div>
        <div class="content-part"><img src="assets/success.png"></div>
        <h2 class="text-center">Payment Sucessful</h2>
        <div *ngIf="!bannerPlan" style="text-align:center; font-weight: 600;">
          <p>Your Business profile is now visible in the global business directory</p>
        </div>

        <div style="text-align:center;color:orange;">
          <h2></h2>
        </div>
        <div class="row plan-name">
          <div class="col-sm-12 col-md-6">
            <h2>Total Amount</h2>
          </div>
          <div class=" col-sm-12 col-md-6 float-right">
            <h2  class="pull-right">${{ !bannerPlan  ? ((plan.amount == 995) ? (plan.amount-500) : (plan.amount-(plan.amount*0.35))) : (total*0.5) }}</h2>
          </div>
          <div  class="col-md-6">
            <p>Plan Price</p>
          </div>
          <div class="col-md-6 float-right">
            <p class="pull-right">${{!bannerPlan ? plan.amount : (total)}}</p>
          </div>
          <div *ngIf="!bannerPlan" class="col-md-6">
            <!-- <p>(${{plan.discount}} discount on current price)</p> -->
          </div>
          <div *ngIf="!bannerPlan" class="col-md-6 float-right">
            <p class="pull-right"></p>
          </div>
          <div *ngIf="!bannerPlan"  class="col-md-6">
            <p>Discount Coupon Applied</p>
          </div>
          <!-- <div *ngIf="!bannerPlan " class="col-md-6 float-right">
            <p class="pull-right">$500</p>
          </div> -->
          <div *ngIf="!bannerPlan" class="col-md-6 float-right">
            <p class="pull-right">{{ (plan.amount == 995) ? '$500' : '35%' }}</p>
          </div>
        </div>
        

        <div *ngIf="!bannerPlan"  class="text-center">
          <p>Thank you for subscribing.<br>
            Got questions? <a class="color">premium@ravel.faith</a></p>
        </div>

        <div *ngIf="bannerPlan"  class="text-center">
          <p>Thank you for subscribing.<br>
            Got questions? <a class="color">premium@ravel.faith</a></p>
        </div>


        <div class="row">
          <button (click)=redirectTo() type="submit" class="submit-button btn btn-primary mb-2 button-c">Done</button>
        </div>
      </div>
    </div>
  </div>





</div>